import styled from 'styled-components';

export const ButtonTag = styled.button`
  margin: 3px;
  border-radius: 5px;
  background-color: white;
  transition:
    300ms linear background,
    border;
  border: 1px solid #f0f0f1;

  &:active,
  &:focus {
    box-shadow: none;
    outline: none;
    background-color: white;
  }

  &:hover {
    background-color: #f2f2f2;
  }

  &.selected {
    border: 1px solid #989898;
    z-index: 10;
  }

  &.btn.no-cursor {
    /* need this to break bootstrap inheritance */
    cursor: default;

    &:hover {
      background: white;
      border: 1px solid #f0f0f1;
    }
  }

  cursor: pointer;
  &.selected {
    border: 1px solid #989898;
  }

  &:disabled {
    cursor: default;
  }
`;
